import React, { useState, useEffect, useRef } from "react";
import "./VehicleForm.css";

// components imports
import Loader from "../../../../../Components/CircularLoader/CircularLoader";

// apis imports
import {
  createNewVehicle,
  editVehicle,
} from "../../../../../services/vehicles.services";

// library imports
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { CgColorPicker } from "react-icons/cg";
import { useTranslation } from "react-i18next";

const initialData = {
  license_plate: "",
  color: "#5a6876",
  year: "",
  make: "",
  model: "",
  type: "",
  weight_in_lbs: "",
  volume_in_cbm: "",
  active: "false",
};

export default function VehicleForm({ open, setOpen, setSnack, setRefresh }) {
  const { t } = useTranslation("carrier");
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);

  const colorPickerRef = useRef(null);

  const handleIconClick = () => {
    if (colorPickerRef.current) {
      colorPickerRef.current.click();
    }
  };

  useEffect(() => {
    setData(initialData);
  }, [open]);

  const handleClose = () => setOpen(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const saved = await createNewVehicle(data);
      if (saved.error) {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text:
              saved?.error?.response?.data?.message || t("common:messages.somethingWentWrong"),
            severity: "error",
          };
        });
        setLoading(false);
      } else {
        setRefresh(Math.floor(Math.random() * 100) + 1);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: saved?.data?.message,
            severity: "success",
          };
        });
        setData(initialData);
        setLoading(false);
        handleClose();
      }
    } catch (error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
      setLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { created_at, updated_at, ...carDetails } = data;
      const saved = await editVehicle(carDetails, open?.id);
      if (saved.error) {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text:
              saved?.error?.response?.data?.message || t("common:messages.somethingWentWrong"),
            severity: "error",
          };
        });
        setLoading(false);
      } else {
        setRefresh(Math.floor(Math.random() * 100) + 1);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: saved?.data?.message,
            severity: "success",
          };
        });
        setLoading(false);
        handleClose();
      }
    } catch (error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open?.id) {
      setData(open);
    }
  }, [open?.id]);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        // onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Form onSubmit={open?.id ? handleUpdate : handleSave}>
          <div className="manage__vehicle_modal">
            <div className="manage__vehicle_modalheading">
              {open?.id ? t("vehicles.editVehicleTitle") : t("vehicles.addVehicle")}
            </div>
            <div className="manage__vehicle_modalcontent">
              <div className="manage__vehicle_modalrow">
                <div className="manage__vehicle_modalinputwrap">
                  <Form.Label>{t("vehicles.licensePlate")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__vehicle_modalinput"
                    placeholder={t("vehicles.licensePlate")}
                    name="license_plate"
                    value={data.license_plate}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="manage__vehicle_modalrow">
                <div className="manage__vehicle_modalinputwrap">
                  <Form.Label>{t("vehicles.color")}</Form.Label>
                  <div className="d-flex gap-2">
                    <CgColorPicker
                      size={30}
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleIconClick}
                    />
                    <div
                      className="add__vehmodal_colorview"
                      style={{
                        background: data?.color,
                      }}
                    ></div>
                  </div>

                  <Form.Control
                    type="color"
                    placeholder={t("vehicles.color")}
                    name="color"
                    value={data.color}
                    ref={colorPickerRef}
                    onChange={handleChange}
                    className="add__vehmodal_colorpicker"
                  />
                </div>
                <div className="manage__vehicle_modalinputwrap">
                  <Form.Label>{t("vehicles.year")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__vehicle_modalinput"
                    placeholder={t("vehicles.year")}
                    type="number"
                    name="year"
                    value={data.year}
                    onChange={handleChange}
                  />
                </div>
                <div className="manage__vehicle_modalinputwrap">
                  <Form.Label>{t("vehicles.make")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__vehicle_modalinput"
                    placeholder={t("vehicles.make")}
                    name="make"
                    value={data.make}
                    onChange={handleChange}
                  />
                </div>
                <div className="manage__vehicle_modalinputwrap">
                  <Form.Label>{t("vehicles.model")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__vehicle_modalinput"
                    placeholder={t("vehicles.model")}
                    name="model"
                    value={data.model}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="manage__vehicle_modalrow">
                <div className="manage__vehicle_modalinputwrap">
                  <Form.Label>{t("vehicles.type")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__vehicle_modalinput"
                    type="text"
                    value={data.type}
                    placeholder={t("vehicles.type")}
                    name="type"
                    onChange={handleChange}
                  />
                </div>
                <div className="manage__vehicle_modalinputwrap">
                  <Form.Label>{t("vehicles.weightInPounds")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__vehicle_modalinput"
                    type="number"
                    value={data.weight_in_lbs}
                    placeholder={t("vehicles.weightInPounds")}
                    name="weight_in_lbs"
                    onChange={handleChange}
                  />
                </div>
                <div className="manage__vehicle_modalinputwrap">
                  <Form.Label>{t("vehicles.volumeInCbm")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__vehicle_modalinput"
                    type="number"
                    name="volume_in_cbm"
                    placeholder={t("vehicles.volumeInCbm")}
                    value={data.volume_in_cbm}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="manage__vehicle_modalfooter">
              <div className="manage__vehicle_modalcncl" onClick={handleClose}>
                {t("common:actions.cancel")}
              </div>
              <Button
                disabled={loading}
                className={`manage__vehicle_modalsave`}
                type="submit"
              >
                {loading ? <Loader /> : t("common:actions.save")}
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </div>
  );
}
